<al-budget-group-base [node]="node"
                      [translationKey]="translationKey"
                      [icon]="faIdBadge"
                      [refreshSubject]="refreshSubject" />

<al-cell-drop-zone [node]="node"
                   [droppable]="isDroppable"
                   (dragOverDelay)="expand()" />